import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service'
import { AppConfigService } from '../../shared/appconfig/appconfig.service'
import { UserProfile } from '../../shared/models/core.model'
import { MenuService } from '../menu/menu.service'
import { forEach } from 'lodash';

export { UserProfile } from '../../shared/models/core.model'

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  public profile: UserProfile;

  constructor(
    private http: HttpClient, private authService: AuthService,
    private menuService: MenuService,
    @Inject('BASE_URL') baseUrl: string) {

    this.profile = {
      firstName: '',
      lastName: '',
      companyName: '',
      phoneNumber: '',
      status: 'profile',
      privileges: ['Onboarding'],
      clientJson: '',
      customerId: '',
      paymentMethodId: '',
      email: '',
      country: '',
      postalCode: ''
    };

  }

  isLoaded(): boolean {
    if (this.profile) {
      return true;
    }

    return false;
  }

  hasPrivilege(priv: string): boolean {
    if (this.profile) {
      if (this.profile.privileges !== null && this.profile.privileges.indexOf(priv) >= 0) {
        return true;
      }
    }
    return false;
  }

  hasAnyPrivilege(priv: string[]): boolean {
    for (var i = 0; i < priv.length; i++) {
      let p = priv[i];
      if (this.hasPrivilege(p)) {
        return true;
      }
    }

    return false;
  }

  isOnboarding(): boolean {
    if (this.profile) {
      const hasOnboardingPrivilege = this.profile.privileges !== null && this.profile.privileges.indexOf('Onboarding') >= 0;
      console.log('ProfileService.isOnboarding():', {
        hasPrivileges: this.profile.privileges !== null,
        privileges: this.profile.privileges,
        hasOnboardingPrivilege,
        indexOfOnboarding: this.profile.privileges?.indexOf('Onboarding')
      });
      if (hasOnboardingPrivilege) {
        return true;
      }
    }
    return false;
  }

  isPending(): boolean {
    if (this.profile) {
      if (this.profile.privileges !== null && this.profile.privileges.indexOf('Pending') >= 0) {
        return true;
      }
    }
    return false;
  }

  isBeta(): boolean {
    if (this.profile) {
      if (this.profile.privileges !== null && this.profile.privileges.indexOf('Beta') >= 0) {
        return true;
      }
    }
    return false;
  }

  isActive(): boolean {
    if (this.profile) {
      if (this.profile.status === 'active') return true;
    }
    return false;
  }

  getStatus(): string {
    if (this.profile) {
      if (this.profile.status) return this.profile.status;
    }
    return 'profile';
  }

  load(): Observable<UserProfile> {
    console.log('ProfileService.load() called');
    console.log('isLoggedIn:', this.authService.isLoggedIn());

    if (this.authService.isLoggedIn() === false) {
      console.log('Not logged in, returning default profile:', this.profile);
      return of(this.profile);
    }

    const headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
    const url = AppConfigService.settings.get('apiServer');
    const fullUrl = url + 'profile';

    console.log('Loading profile from:', fullUrl);

    return this.http.get<UserProfile>(fullUrl, { headers: headers }).pipe(
      tap({
        next: (cfg) => {
          console.log('Profile loaded from API:', cfg);
          this.profile = cfg;
          console.log('Profile updated in service:', this.profile);

          if (this.profile.privileges.length === 0) {
            console.log('No privileges returned, adding Onboarding privilege');
            this.profile.privileges.push('Onboarding');
          }
        },
        error: (err) => {
          console.error('Error loading profile from API:', err);
        }
      }),
      switchMap(profile => {
        return this.menuService.load(profile).pipe(
          switchMap(() => of(profile))
        );
      })
    );
  }

  getByEmail(): Observable<UserProfile> {
    if (this.authService.isLoggedIn() === false) {
      return of(this.profile);
    }

    const headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
    const url = AppConfigService.settings.get('apiServer');

    return this.http.get<UserProfile>(url + 'profile', { headers: headers }).pipe(
      tap(cfg => {
        this.profile = cfg;
        console.log(this.profile);

        if (this.profile.privileges.length === 0) {
          this.profile.privileges.push('Onboarding');
        }
      }),
      switchMap(profile => {
        return this.menuService.load(profile).pipe(
          switchMap(() => of(profile))
        );
      })
    );
  }

  save(p: UserProfile): Observable<UserProfile> {
    if (this.authService.isLoggedIn() === false) {
      return of(this.profile);
    }

    const headers = new HttpHeaders({ 'Authorization': this.authService.getAuthorizationHeaderValue() });
    const url = AppConfigService.settings.get('apiServer');

    return this.http.post<UserProfile>(url + 'profile', p, { headers: headers }).pipe(
      tap(cfg => {
        this.profile = cfg;
        console.log(this.profile);
      }),
      switchMap(profile => {
        return this.menuService.load(profile).pipe(
          switchMap(() => of(profile))
        );
      })
    );
  }

}


